module.exports = __webpack_public_path__ + "img/430.55049354.svg";